<template>
  <v-dialog v-model="show" width="700px" :fullscreen="fullscreen">
    <custom-dialog
      @close="show = false"
      :fullscreen="fullscreen"
      color="accent"
      :title="this.generateMessage('actionplans.list_action_not_ended.title')"
      @fullscreen="handleFullscreenClick"
    >
      <p>
        {{ this.generateMessage('actionplans.list_action_not_ended.text') }}
      </p>
      <v-card>
        <v-virtual-scroll height="250" item-height="70" :items="items">
          <template v-slot:default="{ item }">
            <v-list-item :key="item.id">
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.id }} - {{ item.current_act_status_type_name }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ item.description }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider />
          </template>
        </v-virtual-scroll>
      </v-card>

      <template v-slot:actions>
        <v-btn class="mx-2" color="success" small @click.stop="validate">
          {{ generateMessage('actionplans.list_action_not_ended.submit_btn') }}
        </v-btn>
        <v-btn class="mx-2" color="primary" small @click.stop="show = false">
          {{ generateMessage('actionplans.list_action_not_ended.cancel_btn') }}
        </v-btn>
      </template>
    </custom-dialog>
  </v-dialog>
</template>

<script>
import { generateMessage } from '@/utils/i18n';
import CustomDialog from '../../CustomDialog';

export default {
  name: 'ListActionNotEnded',
  components: { CustomDialog },
  props: {
    value: Boolean,
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      fullscreen: false,
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    generateMessage,
    validate() {
      this.show = false;
      this.$emit('clicked');
    },
    handleFullscreenClick() {
      this.fullscreen = !this.fullscreen;
    },
  },
};
</script>
